import { FC, ReactNode } from "react"
import { Box, Dialog, IconButton, DialogTitle, DialogContent, useMediaQuery, useTheme } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

interface AttachmentModelProps {
  title: ReactNode
  open: boolean
  onClose: () => void
  children: ReactNode
}

export const AttachmentModel: FC<AttachmentModelProps> = ({
  title,
  open,
  onClose,
  children,
}) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="lg"
      PaperProps={{
        sx: {
          maxWidth: "unset",
          width: "80vw",
          height: "80vh",
          maxHeight: "80vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: 2,
          height: "calc(80vh - 60px)",
          overflow: "auto",
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  )
}
